import { Table } from "react-bootstrap";
import Laoder from "../../../components/loading/Loader";
import { Fragment } from "react";
import jalaliTime from "../../../functions/jalaliTime";
import useUserInformation from "../../../hooks/useUserInformation";
import getMethodPayment from "../../../functions/getMethodPayment";
import CompanyEnum from "../../../enums/company/CompanyEnum";
import PrintLink from "../../../components/shipment/Factor/PrintLink";

function TableShipments({ shipments = [], count = 0, isLoading, page, items }) {
  const { isDistrictManger } = useUserInformation();

  return (
    <section className="w-100 px-1 overflow-x-auto mt-4">
      <h5 className="text-success">
        <span>تعداد مرسولات:</span>
        <span className="me-2">{count.toLocaleString()}</span>
      </h5>
      <Table bordered={true} striped={true} className="text-center">
        <thead>
          <tr>
            <th>ردیف</th>
            <th>شماره سفارش</th>
            <th>تاریخ</th>
            <th>سرویس دهنده</th>
            <th>{isDistrictManger ? "نام سرپرست" : "نام نماینده"}</th>
            <th>فرستنده</th>
            <th>گیرنده</th>
            <th>نوع پرداخت</th>
            <th>مبلغ (ریال)</th>
            <th>وضعیت</th>
          </tr>
        </thead>
        <tbody>
          {isLoading === true && (
            <tr>
              <td colSpan="10">
                <Laoder />
              </td>
            </tr>
          )}
          {isLoading === false &&
            shipments.map((item, idx) => (
              <tr key={item.id} className="align-middle">
                <td>{idx + 1 + (page - 1) * items}</td>
                <td>
                  <PrintLink ids={[item.id]}>{item.numberParcel}</PrintLink>
                </td>
                <td>
                  <span style={{ whiteSpace: "pre" }}>
                    {jalaliTime(item.created_at).full}
                  </span>
                </td>
                <td>{CompanyEnum[item.componyId]}</td>
                <td>
                  {isDistrictManger ? (
                    <Fragment>
                      <span>{item.source.supervisor?.user?.name}</span>
                      <span> {item.source.supervisor?.user?.family}</span>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <span>{item?.agent?.user?.name ?? ""}</span>
                      <span> {item?.agent?.user?.family ?? ""}</span>
                    </Fragment>
                  )}
                </td>
                <td>
                  <span>{item.source.province.faName}</span>
                  <span> {item.source.city.faName}</span>
                  <span> - </span>
                  {item.source.type === 0 ? (
                    <Fragment>
                      <span>{item.source.name}</span>
                      <span> {item.source.family}</span>
                    </Fragment>
                  ) : (
                    <span>{item.source.compony}</span>
                  )}
                </td>
                <td>
                  <span>{item.destination.province.faName}</span>
                  <span> {item.destination.city.faName}</span>
                  <span> - </span>
                  {item.destination.type === 0 ? (
                    <Fragment>
                      <span>{item.destination.name}</span>
                      <span> {item.destination.family}</span>
                    </Fragment>
                  ) : (
                    <span>{item.destination.compony}</span>
                  )}
                </td>
                <td>
                  {getMethodPayment({
                    amountCOD: item.amountCOD,
                    isCod: item.isCod,
                  })}
                </td>
                <td>{(item.realPayable + item.amountCOD)?.toLocaleString()}</td>
                <td>
                  {item.status === "تحویل داده شده"
                    ? "تحویل سرویس دهنده"
                    : item.status}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </section>
  );
}

export default TableShipments;
